<template>
  <div id="home-view">
    <div class="main-logo ml-title cobblebox">
      <img id="gear-img" src="../assets/gear-logo.png" alt>
      <img id="text-img" src="../assets/text-logo-transparent.png" alt>
      <span id="beta">
        BETA
      </span>
    </div>
    <MainLayout :user="user" :displayHead="true">
      <div id="home-board">
        <div id="circle">
          <button @click.prevent="triggerDownload" class="light">Play</button>
          <button @click.prevent="() => $router.push(`/about`)">About</button>
          <button @click.prevent="() => window.location.href = `https://paypal.me/gearcaster`">
            Donate
          </button>
        </div>
        <div id="float-buttons-container">
          <div class="side">
            <div class="butt top-button cobblebox is-hidden-mobile" style="margin-right: 100%; text-align: left;">
              <p><span class="entypo entypo-bag"></span> Shop</p>
            </div>
            <div class="butt bottom-button cobblebox is-hidden-mobile" style="margin-right: 100%; text-align: left;">
              <p><span class="entypo entypo-user"></span> Profile</p>
            </div>
          </div>
          <div class="side">
            <div class="butt top-button cobblebox is-hidden-mobile" style="margin-left: auto; text-align: right;">
              <p>Collection <span class="entypo entypo-archive"></span></p>
            </div>
            <div class="butt bottom-button cobblebox is-hidden-mobile" style="margin-left: auto; text-align: right;">
              <p>Open Packs <span class="entypo entypo-book"></span></p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div id="home-board">
        <div id="circle">
          <button @click.prevent="() => $router.push(`/hangout`)">The Hangout</button>
          <button v-if="!aiDuelID" @click.prevent="startAIDuel">Practice Room</button>
          <button v-else @click.prevent="() => $router.push(`/duel/${user.username}`)">Continue Practice</button>
          <button disabled>coming soon</button>
        </div>
        <div id="float-buttons-container">
          <div class="side">
            <div class="butt top-button cobblebox" style="margin-right: 100%; text-align: left;">
              <p><span class="entypo entypo-bag"></span> Shop</p>
            </div>
            <div class="butt bottom-button cobblebox" style="margin-right: 100%; text-align: left;">
              <p><span class="entypo entypo-user"></span> Profile</p>
            </div>
          </div>
          <div class="side">
            <div class="butt top-button cobblebox" style="margin-left: auto; text-align: right;">
              <p>Collection <span class="entypo entypo-archive"></span></p>
            </div>
            <div class="butt bottom-button cobblebox" style="margin-left: auto; text-align: right;">
              <p>Open Packs <span class="entypo entypo-book"></span></p>
            </div>
          </div>
        </div>
      </div> -->
    </MainLayout>
  </div>
</template>

<script>
import MainLayout from "@/views/MainLayout.vue";
import api from "../api";

export default {
  components: { MainLayout },
  props: {
    user: Object,
    invitationTag: String
  },
  data: () => {
    return { aiDuelID: false };
  },
  computed: {
    window() { return window }
  },
  mounted() {
    this.$socket.emit("duel.list");
  },
  sockets: {
    listDuels(data) {
      this.aiDuelID = !!data.find((game) => game.id == this.user.username);
      console.log(data.map(g => g.id));
    }
  },
  methods: {
    triggerDownload() {
      const { invitationTag } = this;

      console.log(invitationTag);

      if (invitationTag) {
        const headers = {
          'x-invitation-tag': invitationTag
        };

        api.post('/user_engaged', undefined, { headers })
          .then((res) => {
            if (res.ok) console.log('ok!');
            else console.log(res);
          })
          .catch(() => null);
      }

      window.open('https://apps.apple.com/us/app/gearcaster/id1479473184', '_blank');
    },
    startAIDuel() {
      this.$socket.emit("duel.new.ai", (err, gameID) => {
        if (err) {
          this.$alert(err);
        } else {
          this.$router.push({ name: "duel", params: { id: gameID } });
        }
      });
    }
  }
};
</script>
<style scoped>
#home-board {
  height: 100%;
  width: 100%;
  background-image: url('../assets/backgrounds/tatami.png');
  background-size: cover;
  background-position: center center;
  display: flex;
  align-items: center;
  justify-content: center;
}
#float-buttons-container {
  z-index: 10;
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 800px;
  margin: 28px auto;
  padding: 0 1em;
  display: flex;
  flex-direction: row;
}
#float-buttons-container .side {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
#float-buttons-container .butt {
  display: inline-block;
  font-size: 18px;
  font-weight: bold;
  line-height: 100%;
  text-align: center;
  padding: 10px 1em;
}
#float-buttons-container .butt .entypo {
  font-weight: normal;
}
#float-buttons-container .top-button {
  min-width: 165px;
  margin-bottom: 1em;
}
#float-buttons-container .bottom-button {
  min-width: 180px;
}
.main-logo {
  height: 85px;
  width: 206px;
  margin: 2em auto -60px auto;
  z-index: 10;
}
.main-logo #beta {
  height: 27px;
  width: 56px;
  border-radius: 3px;
  border: 1px solid #FF5F58;
  background: radial-gradient(circle, #F36 0%, #FF5F58 100%);
  box-shadow: 0 2px 6px 0 rgba(0,0,0,0.5);
  color: white;
  font-size: 15px;
  bottom: -13px;
  position: absolute;
  right: calc(56px / -2);
  text-align: center;
}
.main-logo > img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.main-logo > #gear-img {
  height: 60px;
  margin: auto;
}
.main-logo > #text-img {
  height: 40px;
  margin: auto;
  padding: 2px;
  background: #454545;
}
.main-logo #gear-img {
  animation: spin 2s 0s linear infinite;
}

@keyframes spin {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(60deg);
  }
}

#circle {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 300px;
  height: 300px;
  overflow: hidden;
  border: solid 14px transparent;
  border-radius: 50%;
  background:#bdbdbd;
  box-shadow:0 0 0 10px #808080, 0 2px 6px 0 rgba(0,0,0,0.5);
}

#circle button {
  width: 110%;
}

#circle button:nth-child(2) {
  margin: 20px 0;
}

@media screen and (max-width: 720px) {
  .main-logo {
    margin-bottom: 1em;
  }
  #float-buttons-container {
    margin-bottom: 5px;
  }
  #circle {
    margin-bottom: 2em;
  }
  #float-buttons-container .butt {
    font-size: 14px;
    font-weight: bold;
    line-height: 100%;
    text-align: center;
    padding: 6px 1em;
  }
  #float-buttons-container .butt {
    min-width: 165px;
  }
}
</style>
